interface HiddenColumnsStorageKeys {
  defaultHiddenColumnsKey: string
  hiddenColumnsKey: string
  knownColumnsKey: string
}

export const getHiddenColumnsStorageKeys = (tableId?: string): HiddenColumnsStorageKeys => ({
  defaultHiddenColumnsKey: `ds-default-hidden-columns-${tableId}`,
  hiddenColumnsKey: `ds-column-visibility-${tableId}`,
  knownColumnsKey: `ds-known-default-hidden-columns-${tableId}`,
})
